module.exports = __webpack_public_path__ + "static/media/at.e006579c.svg";